import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminPage from '../AdminPage';
import TTSStudioPage from '../TTSStudio/TTSStudioPage';
import MediaManagerPage from '../Media/MediaManagerPage';
import AdminLoginPage from '../Login/AdminLoginPage';

const AdminRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminPage />} />
      <Route path="/tts-studio" element={<TTSStudioPage />} />
      <Route path="/media" element={<MediaManagerPage />} />
      <Route path="/login" element={<AdminLoginPage />} />
      <Route path="*" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default AdminRoutes;
